import { createRoot } from 'react-dom/client';
import { App } from './App';
import './styles/global.css';

// デバッグが必要なときは URL に ?debug=1 を付けると eruda（モバイル用
// in-page コンソール）が起動する。
if (import.meta.env.DEV && new URLSearchParams(location.search).has('debug')) {
  const s = document.createElement('script');
  s.src = 'https://cdn.jsdelivr.net/npm/eruda';
  s.onload = () => {
    const w = window as unknown as { eruda?: { init: () => void } };
    w.eruda?.init();
  };
  document.body.appendChild(s);
}

// StrictMode は AR セッション (8th Wall + WebGL + getUserMedia) の二重実行を
// 起こしてカメラ獲得競合や canvas 破棄競合の原因になるため、有効化していない。
createRoot(document.getElementById('root')!).render(<App />);
